// ⚠️  GENERATED — do not edit. Run `npm run inferrex:generate` to regenerate.
/**
 * @inferrex/sdk — Billing resource client
 * Generated from route definitions in services/api/route-definitions.ts
 */

import type { HttpClient, RequestOptions } from '../http.js';

export class BillingClient {
  constructor(private readonly http: HttpClient) {}

  /** Get Billing Status via the Inferrex API. */
  async getBillingStatus(): Promise<{ status: string; tier: string; trialEndsAt: string | null; stripeCustomerId: string | null; subscriptionId: string | null; paymentStatus: string; gracePeriodEndsAt: string | null; profileComplete: boolean; companyName: string | null }> {
    return this.http.get<{ status: string; tier: string; trialEndsAt: string | null; stripeCustomerId: string | null; subscriptionId: string | null; paymentStatus: string; gracePeriodEndsAt: string | null; profileComplete: boolean; companyName: string | null }>('/v1/billing/status');
  }

  /** Submit Profile via the Inferrex API. */
  async submitProfile(request: { companyName: string; companyWebsite?: string; companySize: string; industry: string; jobTitle: string; phone?: string; useCase: string; systemsToConnect?: string[]; expectedRecordVolume?: string; countryCode: string; billingAddress?: Record<string, unknown>; vatNumber?: string; dataResidency: string }, requestOptions?: RequestOptions): Promise<{ status: string }> {
    return this.http.post<{ status: string }>('/v1/billing/profile', request, requestOptions);
  }

  /** Create Checkout via the Inferrex API. */
  async createCheckout(request: { tier: string; frequency: string; currency: string }, requestOptions?: RequestOptions): Promise<{ checkoutUrl: string }> {
    return this.http.post<{ checkoutUrl: string }>('/v1/billing/checkout', request, requestOptions);
  }

  /** Create Portal Session via the Inferrex API. */
  async createPortalSession(request: { returnUrl?: string }, requestOptions?: RequestOptions): Promise<{ portalUrl: string }> {
    return this.http.post<{ portalUrl: string }>('/v1/billing/portal', request, requestOptions);
  }

  /** Request Upgrade via the Inferrex API. */
  async requestUpgrade(request: { requestedTier: string; reason: string; systemsPlanned?: string[] }, requestOptions?: RequestOptions): Promise<{ requestId: string }> {
    return this.http.post<{ requestId: string }>('/v1/billing/request-upgrade', request, requestOptions);
  }

  /** Purchase Pack via the Inferrex API. */
  async purchasePack(request: { dimension: string; unitSize: number }, requestOptions?: RequestOptions): Promise<{ purchaseId: string; dimension: string; unitSize: number; amountPence: number; allowance: number }> {
    return this.http.post<{ purchaseId: string; dimension: string; unitSize: number; amountPence: number; allowance: number }>('/v1/billing/purchase-pack', request, requestOptions);
  }

  /** Import Stripe Catalog via the Inferrex API. */
  async importStripeCatalog(requestOptions?: RequestOptions): Promise<{ products: number; prices: number; features: number; attachments: number }> {
    return this.http.post<{ products: number; prices: number; features: number; attachments: number }>('/v1/admin/billing/import', undefined, requestOptions);
  }

  /** Sync Stripe Catalog via the Inferrex API. */
  async syncStripeCatalog(requestOptions?: RequestOptions): Promise<{ created: number; updated: number; grandfathered: number; offersSynced: number }> {
    return this.http.post<{ created: number; updated: number; grandfathered: number; offersSynced: number }>('/v1/admin/billing/sync', undefined, requestOptions);
  }

  /** Rollback Change via the Inferrex API. */
  async rollbackChange(id: string, requestOptions?: RequestOptions): Promise<{ id: string; rolledBack: boolean }> {
    return this.http.post<{ id: string; rolledBack: boolean }>(`/v1/admin/billing/changelog/${id}/rollback`, undefined, requestOptions);
  }
}
